import { render, staticRenderFns } from "./competitiveMarketClimate.vue?vue&type=template&id=c8950454"
import script from "./competitiveMarketClimate.vue?vue&type=script&lang=js"
export * from "./competitiveMarketClimate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports